module.exports = __webpack_public_path__ + "static/img/ai-explaination.80711b6.gif";


//////////////////
// WEBPACK FOOTER
// ./static/gif/ai-explaination.gif
// module id = 5PxM
// module chunks = 1